/**
 * @ngdoc service
 * @name training
 *
 * @description Training api service.
 */
module.factory('training', ['moment', '$filter', function (moment, $filter) {
    'use strict';
    return {
        upgradeTrainings: function (trainings) {
            for (var iActivity = Object.keys(trainings).length - 1; iActivity >=0; iActivity--) {
                var activity = Object.values(trainings)[iActivity];
                activity.icon = $filter('slugify')(activity.title);

                for (var iLevel = activity.competences.length - 1; iLevel >= 0; iLevel--) {
                    var level = activity.competences[iLevel];
                    level.opened = false;
                    level.total = 0;
                    level.completed = 0;

                    for (var iCategory = level.Domaines.length - 1; iCategory >= 0; iCategory--) {
                        var category = level.Domaines[iCategory];
                        category.opened = false;
                        category.total = 0;
                        category.completed = 0;

                        for (var iSubCategory = category['S_Dom'].length - 1; iSubCategory >= 0; iSubCategory--) {
                            var subcategory = category['S_Dom'][iSubCategory];
                            subcategory.opened = false;
                            subcategory.total = subcategory.Competences.length;
                            subcategory.completed = subcategory.Competences.filter(function (competency) {
                                return competency.acquis === 100;
                            }).length;

                            category.total += subcategory.total;
                            category.completed += subcategory.completed;
                        }

                        level.total += category.total;
                        level.completed += category.completed;
                    }
                }
                activity.competences.sort(function (current, next) {
                    return current.id - next.id;
                });
            }

            console.log('trainings:', trainings);

            return trainings;
        },
        upgradeTrainingsDomaine: function (trainings) {
            for (var iActivity = Object.keys(trainings).length - 1; iActivity >=0; iActivity--) {
                var activity = Object.values(trainings)[iActivity];
                activity.icon = $filter('slugify')(activity.title);

                for (var iCategory = Object.keys(activity.Domaines).length - 1; iCategory >= 0; iCategory--) {
                    var category = Object.values(activity.Domaines)[iCategory];
                    category.opened = false;
                    category.total = 0;
                    category.completed = 0;

                    for (var iSubCategory = Object.keys(category['S_Dom']).length - 1; iSubCategory >= 0; iSubCategory--) {
                        var subcategory = Object.values(category['S_Dom'])[iSubCategory];
                        subcategory.opened = false;
                        subcategory.total = subcategory.Competences.length;
                        subcategory.completed = subcategory.Competences.filter(function (competency) {
                            return competency.acquis === 100;
                        }).length;

                        category.total += subcategory.total;
                        category.completed += subcategory.completed;
                    }
                }

                // activity.competences.sort(function (current, next) {
                //     return current.id - next.id;
                // });
            }

            console.log('trainings by domains :', trainings);

            return trainings;
        },
        /*
        getTrainings: function () {
            return $q.resolve({
                levels: {
                    1: {
                        title: 'débutant',
                        subtitle: 'vous n’avez jamais navigué ou presque.'
                    },
                    2: {
                        title: 'perfectionnement',
                        subtitle: 'vous possédez déjà quelques bases.'
                    },
                    3: {
                        title: 'évolution',
                        subtitle: 'vous contribuez activement à la marche du bateau.'
                    },
                    4: {
                        title: 'autonome',
                        subtitle: 'vous avez déjà de sérieuses références.'
                    },
                    5: {
                        title: 'maîtrise',
                        subtitle: 'vous maîtrisez les compétences pour naviguer en bateau.'
                    }
                },
                categories: [
                    {
                        file: {
                            id: "1",
                            uri: "http://glenans-b2c-drupal.service.dev.local.niji.delivery/file1.pdf",
                            created: "09/14/2016"
                        },
                        title: 'Croisière',
                        icon: 'croisiere',
                        level: 1,
                        levels: {
                            1: {
                                completed: '2/146',
                                sublevels: [
                                    {
                                        title: 'Conduite',
                                        completed: '2/21',
                                        skills: [
                                            {
                                                title: 'Conduite sous voile',
                                                description: 'Percevoir la direction du vent. Différencier les allures de près et de portant. Avancer et se diriger à toutes les allures. Réguler sa vitesse aux allures de près.',
                                                completed: '2/6',
                                                subskills: [
                                                    {
                                                        name: 'Gonfler la voile pour avancer',
                                                        rating: 50
                                                    },
                                                    {
                                                        name: 'Utiliser la barre pour se diriger',
                                                        rating: 100
                                                    },
                                                    {
                                                        name: 'Utiliser la voile pour ralentir',
                                                        rating: 0
                                                    },
                                                    {
                                                        name: 'Utiliser la barre pour ralentir',
                                                        rating: 0
                                                    },
                                                    {
                                                        name: 'Sur la plage ou à l’arret, sur l’eau, savoir d’où vient le vent',
                                                        rating: 0
                                                    },
                                                    {
                                                        name: 'Différencier les allures de près des allures portantes',
                                                        rating: 0
                                                    }
                                                ]
                                            },
                                            {
                                                title: 'Réglages du profil des voiles',
                                                completed: '0/8'
                                            },
                                            {
                                                title: 'Conduite au moteur',
                                                completed: '0/7'
                                            }
                                        ]
                                    },
                                    {
                                        title: 'Manoeuvre',
                                        completed: '0/32'
                                    },
                                    {
                                        title: 'Navigation',
                                        completed: '0/27'
                                    }
                                ]
                            },
                            2: {
                                completed: '0/200'
                            }
                        }
                    },
                    {
                        file: {
                            id: "1",
                            uri: "http://glenans-b2c-drupal.service.dev.local.niji.delivery/file2.pdf",
                            created: "09/14/2016"
                        },
                        title: 'Catamaran',
                        icon: 'catamaran',
                        level: 2,
                        levels: {
                            1: {
                                completed: '4/120',
                                sublevels: [
                                    {
                                        title: 'Direction',
                                        completed: '4/12',
                                        skills: [
                                            {
                                                title: 'Direction sous grand vent',
                                                description: 'Percevoir la direction du vent. Différencier les allures de près et de portant. Avancer et se diriger à toutes les allures. Réguler sa vitesse aux allures de près.',
                                                completed: '2/4',
                                                subskills: [
                                                    {
                                                        name: 'Gonfler la voile pour avancer',
                                                        rating: 0
                                                    },
                                                    {
                                                        name: 'Utiliser la barre pour se diriger',
                                                        rating: 50
                                                    },
                                                    {
                                                        name: 'Utiliser la voile pour ralentir',
                                                        rating: 100
                                                    },
                                                    {
                                                        name: 'Utiliser la barre pour ralentir',
                                                        rating: 100
                                                    }
                                                ]
                                            },
                                            {
                                                title: 'Réglages du profil des voiles',
                                                completed: '0/3'
                                            },
                                            {
                                                title: 'Conduite au moteur',
                                                completed: '2/5'
                                            }
                                        ]
                                    },
                                    {
                                        title: 'Distinction',
                                        completed: '0/32'
                                    },
                                    {
                                        title: 'Avance rapide',
                                        completed: '0/27'
                                    }
                                ]
                            },
                            2: {
                                completed: '0/160'
                            }
                        }
                    },
                    {
                        file: {
                            id: "1",
                            uri: "http://glenans-b2c-drupal.service.dev.local.niji.delivery/file3.pdf",
                            created: "09/14/2016"
                        },
                        title: 'Dériveur',
                        icon: 'deriveur',
                        level: 5
                    },
                    {
                        file: {
                            id: "1",
                            uri: "http://glenans-b2c-drupal.service.dev.local.niji.delivery/file4.pdf",
                            created: "09/14/2016"
                        },
                        title: 'Windsurf',
                        icon: 'windsurf',
                        level: 2
                    },
                    {
                        file: {
                            id: "1",
                            uri: "http://glenans-b2c-drupal.service.dev.local.niji.delivery/file5.pdf",
                            created: "09/14/2016"
                        },
                        title: 'Kitesurf',
                        icon: 'kitesurf',
                        level: 1
                    },
                    {
                        file: {
                            id: "1",
                            uri: "http://glenans-b2c-drupal.service.dev.local.niji.delivery/file6.pdf",
                            created: "09/14/2016"
                        },
                        title: 'Kayak de mer',
                        icon: 'kayak',
                        level: 4
                    }
                ]
            });
        },
        */
        upgradeLevels: function (levels, levelId, isRTQ) {
            var aLevels = [];
            var lastUpdated;

            for (var iLevel = levels.length - 1; iLevel >= 0; iLevel--) {
                var level = levels[iLevel];
                aLevels.push(level);

                level.opened = level.id.includes(levelId);
                level.total = 0;
                level.completed = 0;
                // TODO: change condition to detect difference between false value and unset value
                level.confirmation = angular.copy(isRTQ ? level.validRTQ : level.valid);
                level.confirmationInstructor = angular.copy(level.N_valide_encadr);
                level.confirmationRtq = angular.copy(level.N_valide_rtq);

                for (var iCategory = level.categories.length - 1; iCategory >= 0; iCategory--) {
                    var category = level.categories[iCategory];
                    category.opened = false;
                    category.total = 0;
                    category.completed = 0;

                    for (var iSubCategory = category.subcategories.length - 1; iSubCategory >= 0; iSubCategory--) {
                        var subcategory = category.subcategories[iSubCategory];
                        subcategory.opened = false;
                        subcategory.total = 0;
                        subcategory.completed = 0;

                        for (var iCompetency = subcategory.competencies.length - 1; iCompetency >=0; iCompetency--) {
                            var competency = subcategory.competencies[iCompetency];
                            competency.opened = false;

                            subcategory.total += 1;
                            if (competency.acquis === 100) {
                                subcategory.completed += 1;
                            }
                        }

                        category.total += subcategory.total;
                        category.completed += subcategory.completed;
                    }

                    level.total += category.total;
                    level.completed += category.completed;
                }
            };

            // aLevels.sort(function (current, next) {
            //     return current.id - next.id;
            // });
            aLevels.reverse();

            return aLevels;
        },
        upgradeCompetencies: function (competencies, dLabels, internship) {
            console.log({'upgradeCompetencies': competencies});

            var watched = [];
            var levelId = internship.product.level.value;
            var lastUpdated;

            for (var iCategory = competencies.categories.length - 1; iCategory >= 0; iCategory--) {
                var category = competencies.categories[iCategory];
                category.opened = false;
                category.total = 0;
                category.completed = 0;

                for (var iSubCategory = category.subcategories.length - 1; iSubCategory >= 0; iSubCategory--) {
                    var subcategory = category.subcategories[iSubCategory];
                    subcategory.opened = false;
                    subcategory.total = 0;
                    subcategory.completed = 0;

                    for (var iCompetency = subcategory.competencies.length - 1; iCompetency >=0; iCompetency--) {
                        var competency = subcategory.competencies[iCompetency];
                        competency.labels = angular.copy(dLabels);
                        if (competency.idStageAcquisTotal && competency.idStageAcquisTotal !== internship.sfid) {
                            // previously evaluated during another internship, disable "Acquis partiel" and "Non acquis" choice
                            competency.labels[0].disabled = true;
                            competency.labels[1].disabled = true;
                        } else if (competency.idStageAcquisPartiel && competency.idStageAcquisPartiel !== internship.sfid) {
                            // previously evaluated during another internship, disable "Non acquis" choice
                            competency.labels[0].disabled = true;
                        }
                        subcategory.total += 1;
                        if (competency.acquis === 100) {
                            subcategory.completed += 1;
                        }
                        if (competency.LastModifiedDate) {
                            if (!lastUpdated || moment(competency.LastModifiedDate).isAfter(lastUpdated)) {
                                lastUpdated = competency.LastModifiedDate;
                            }
                        }
                        // keep evaluationValue as initial value
                        competency.rating = competency.evaluationValue;
                        // add competency to watchers list

                        watched.push({ value: competency, parentSubCategory: subcategory, parentCategory: category});
                    }

                    category.total += subcategory.total;
                    category.completed += subcategory.completed;

                    subcategory.competencies.sort(function (a, b) {
                        return a.level - b.level;
                    });
                }
            }

            return {
                list: watched,
                updated: lastUpdated
            }
        },
        upgradeCompetenciesNiveau: function (competencies, dLabels, internship) {
            console.log({'upgradeCompetenciesNiveau': competencies});

            var watched = [];
            var levelId = internship.product.level.value;
            var lastUpdated;

            console.log({'niveau': competencies.niveau, 'length': competencies.niveau.length, 'value': Object.values(competencies.niveau)});
            competencies.niveau = Object.values(competencies.niveau);

            for (var iNiveau = competencies.niveau.length - 1; iNiveau >= 0; iNiveau--) {
                var niveau = competencies.niveau[iNiveau];

                if(niveau.id.includes(internship.product.level.value)){
                    niveau.opened = true;
                } else {
                    niveau.opened = false;
                }

                niveau.total = 0;
                niveau.completed = 0;

                niveau.categories = Object.values(niveau.categories);

                for (var iCategory = niveau.categories.length - 1; iCategory >= 0; iCategory--) {
                    var category = niveau.categories[iCategory];
                    category.opened = false;
                    category.total = 0;
                    category.completed = 0;

                    category.subcategories = Object.values(category.subcategories);

                    for (var iSubCategory = category.subcategories.length - 1; iSubCategory >= 0; iSubCategory--) {
                        var subcategory = category.subcategories[iSubCategory];
                        subcategory.opened = false;
                        subcategory.total = 0;
                        subcategory.completed = 0;

                        subcategory.competencies = Object.values(subcategory.competencies);

                        for (var iCompetency = subcategory.competencies.length - 1; iCompetency >=0; iCompetency--) {
                            var competency = subcategory.competencies[iCompetency];
                            competency.labels = angular.copy(dLabels);
                            if (competency.idStageAcquisTotal && competency.idStageAcquisTotal !== internship.sfid) {
                                // previously evaluated during another internship, disable "Acquis partiel" and "Non acquis" choice
                                competency.labels[0].disabled = true;
                                competency.labels[1].disabled = true;
                            } else if (competency.idStageAcquisPartiel && competency.idStageAcquisPartiel !== internship.sfid) {
                                // previously evaluated during another internship, disable "Non acquis" choice
                                competency.labels[0].disabled = true;
                            }
                            subcategory.total += 1;
                            if (competency.acquis === 100) {
                                subcategory.completed += 1;
                            }
                            if (competency.LastModifiedDate) {
                                if (!lastUpdated || moment(competency.LastModifiedDate).isAfter(lastUpdated)) {
                                    lastUpdated = competency.LastModifiedDate;
                                }
                            }
                            // keep evaluationValue as initial value
                            competency.rating = competency.evaluationValue;
                            // add competency to watchers list

                            watched.push({ value: competency, parentSubCategory: subcategory, parentCategory: category, niveau: niveau});
                        }

                        category.total += subcategory.total;
                        category.completed += subcategory.completed;

                        subcategory.competencies.sort(function (a, b) {
                            return a.level - b.level;
                        });
                    }

                    niveau.total += category.total;
                    niveau.completed += category.completed;
                }
            }

            return {
                list: watched,
                updated: lastUpdated
            }
        },
        getEvaluations: function () {
            return $q.resolve([
                { internshipId: 'a034E00000CuQ2eQAF', productId: '01t0Y000002XMMAQA4', base: 'BONIFACIO', title: 'Croisière niveau 1', startDate: '2017-11-30', endDate: '2017-12-03', note: '16/20', audience: 'adulte' },
                { internshipId: 'a034E00000CuQ2eQAF', productId: '01t0Y000002XMMAQA4', base: 'BONIFACIO', title: 'Croisière niveau 1', startDate: '2017-11-30', endDate: '2017-12-03', note: '16/20', audience: 'adulte' },
                { internshipId: 'a034E00000CuQ2eQAF', productId: '01t0Y000002XMMAQA4', base: 'BONIFACIO', title: 'Croisière niveau 1', startDate: '2017-11-30', endDate: '2017-12-03', note: '16/20', audience: 'adulte' }
            ]);
        },
        getNotations: function () {
            return $q.resolve({
                notation: '16/20',
                notations: [
                    { label: 'Organisation de la vie à bord du bateau', value: 80 },
                    { label: 'Amabilité de vos moniteurs', value: 60 },
                    { label: 'Ambiance au sein de l\'équipage', value: 80 },
                    { label: 'Compétence de vos moniteurs', value: 55 },
                    { label: 'Organisation de l\'activité nautique', value: 80 },
                    { label: 'Qualité de l\'enseignement pratique', value: 20 },
                    { label: 'Ambiance du groupe', value: 100 },
                    { label: 'Qualité de l\'enseignement théorique', value: 85 },
                ]
            });
        }
    };
}]);
